import "./index.scss";

import { Box, Stack } from "@mui/material";
import TitleWithOptions from "components/TitleWithOptions";
import { WorkoutPlan } from "models/workoutplan";

import CardioDefinedProgram from "./CardioDefinedProgram";

const CardioProgramSection = (props: {
  workoutPlan: WorkoutPlan;
  perceivedExertionOptions: any[];
}) => {
  const { workoutPlan, perceivedExertionOptions } = props;
  const cardioGoal =
    workoutPlan?.cardio_overall_goal?.goal === "TIME"
      ? `Time`
      : workoutPlan?.cardio_overall_goal?.goal === "CALORIES"
      ? `Calories`
      : `Heart Rate`;

  return (
    <section className="cardio-program-section">
      <TitleWithOptions title="Cardio Program" />
      <p className="subsection-title">Overall Goals</p>
      <Box className="goal-summary">
        <GoalSummaryItem label="Sessions per week" value={workoutPlan?.cardio_program_frequency} />
        <GoalSummaryItem
          label="Heart Rate, BPM"
          value={`${workoutPlan?.heart_rate_min}-${workoutPlan?.heart_rate_max}`}
        />
        <GoalSummaryItem label="Goal" value={cardioGoal} />
        <GoalSummaryItem
          label="Minutes per Session"
          value={`${workoutPlan?.cardio_overall_goal?.daily_min_value}-${workoutPlan?.cardio_overall_goal?.daily_max_value}`}
        />
        <GoalSummaryItem
          label="Minutes Weekly"
          value={`${workoutPlan?.cardio_overall_goal?.weekly_min_value}-${workoutPlan?.cardio_overall_goal?.weekly_max_value}`}
        />
        <GoalSummaryItem
          label="Perceived Exeption"
          value={
            perceivedExertionOptions?.find((f) => +f.value === workoutPlan?.perceived_exertion)
              ?.label || ``
          }
        />
      </Box>
      <p className="subsection-title">Defined Program</p>
      <Stack gap={2}>
        {workoutPlan?.cardio_workouts?.length &&
          workoutPlan?.cardio_workouts.map((m, i) => {
            let tags = [];
            m.is_active && tags.push({ text: "Active", type: "green" });
            m.is_express && tags.push({ text: "Express", type: "orange" });
            return (
              <CardioDefinedProgram
                key={`cardioProgram${i}`}
                headerInfo={{
                  exercises: m.exercises,
                  subtitle: "Program Name",
                  tags: tags,
                  title: m.name,
                }}
              />
            );
          })}
      </Stack>
    </section>
  );
};

const GoalSummaryItem = ({ label, value }) => {
  return (
    <Box className="goal-summary-item">
      <p className="section-title">{value}</p>
      <label>{label}</label>
    </Box>
  );
};

export default CardioProgramSection;
